import _ from "lodash"
import { modulo } from "./modulo"

const determineMergingEdge = (allEndPoints, edge) => {
  const endPointIndex = edge.points.length - 1
  const overlappingPoints = allEndPoints.filter(point =>
    pointsOverlap(point, edge.points[endPointIndex])
  )

  // We have merging end points
  if (overlappingPoints.length > 1) {
    edge.points[endPointIndex].kind = "merge-point"
    return edge
  } else {
    return edge
  }
}

const pointsOverlap = (pointA, pointB) => {
  const xFudge = 2.5
  const yFudge = 2.5
  const xModulo = modulo(pointA.x, pointB.x)
  const yModulo = modulo(pointA.y, pointB.y)

  return xModulo <= xFudge && yModulo <= yFudge
}

export const determineMergingEdges = edges => {
  const validEdges = _.compact(edges)
  const allEndPoints = validEdges.map(edge => _.last(edge.points))

  return validEdges.map(edge => {
    return determineMergingEdge(allEndPoints, edge)
  })
}

